import React, { useContext, useEffect, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import {
  Table, Space, Popconfirm, Button, Input,
} from 'antd';
import { useDispatch } from 'react-redux';

import { VerticalContainer } from '../../../components/styled';
import { UserContext } from '../../../context';
import history from '../../../routes/history';
import { getUnidades, deleteUnidade } from '../../../services/unidades';
import { Creators as UnidadeActions } from '../../../store/ducks/unidade';

const { Search } = Input;
const { Column } = Table;
export default function ListUnidades() {
  const [filter, setFilter] = useState('');
  const user = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [unidades, setUnidades] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const dispatch = useDispatch();
  const getUnidadesPaginated = async () => {
    try {
      setLoading(true);
      const unidadesData = await getUnidades(page, filter);
      setUnidades(unidadesData.data);
      setTotal(unidadesData.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUnidadesPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteUnidade(record.id);
    await getUnidadesPaginated();
    dispatch(UnidadeActions.getAllUnidadeRequest());
  }

  function cancel(e) {
    console.log(e);
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter('');
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: '50%' }}
          placeholder="Pesquisar unidade, cnpj, email"
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push('adicionar-unidade');
          }}
          style={{ width: '100%!important' }}
          block
        >
          <PlusOutlined />
          {' '}
          Adicionar unidade
        </Button>
        <br />
        <Table
          size="middle"
          pagination={{ pageSize: 10, total }}
          onChange={handleTableChange}
          style={{ width: '100%' }}
          dataSource={unidades}
          rowKey="id"
          loading={loading}
        >
          <Column title="Código" dataIndex="id" key="id" />
          <Column
            title="Nome"
            dataIndex={['pessoa_juridica', 'nome']}
            key="nome"
          />
          <Column
            title="CNPJ"
            dataIndex={['pessoa_juridica', 'cnpj']}
            key="nome"
          />
          <Column
            title="Ação"
            key="action"
            render={(text, record) => (
              <Space size="middle">
                <a onClick={() => history.push(`unidades/${record.id}`)}>
                  Visualizar
                </a>
                {user?.type === 'ADM'
                && (
                <Popconfirm
                  title="Deseja deletar o unidade?"
                  onConfirm={() => confirm(record)}
                  onCancel={cancel}
                  okText="Sim"
                  cancelText="Não"
                >
                  <a>Deletar</a>
                </Popconfirm>
                )}
              </Space>
            )}
          />
        </Table>
      </VerticalContainer>
    </>
  );
}
